import React from 'react';
import { Button, Box } from '@mui/material';
import './LeaveRequestActionViewStyle.css';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import { TbFileDescription } from 'react-icons/tb';
import CustomTooltip from '../../../../Components/custom_components/CustomTooltip/CustomTooltip';

const LeaveRequestActionView = ({ employeeName, leaveType, remark, onRemarkChange, onAccept, onReject, leaveFrom, leaveTo }) => {
    // const message = `Please take action on ${employeeName} leave request for ${leaveType}, effective ${leaveFrom}, to ${leaveTo}.`;
    const message = `Please take action on ${employeeName} leave request for ${leaveType}, effective ${leaveFrom}, to ${leaveTo}.`;

    return (
        <div className="leave-action-container">
            <CustomTooltip title={message || ""}>
                <span className='leave-action-title' >
                    {/* Please take action on <strong>{employeeName}</strong> leave request for <strong>{leaveType}</strong>, effective {leaveFrom}, to {leaveTo}. */}
                    Please take action on <strong>{employeeName}</strong> leave request for <strong>{leaveType}</strong>, effective {leaveFrom}, to {leaveTo}.
                </span>
            </CustomTooltip>

            <div className="leave-type-custom-textfield-container">
                <CustomTextArea
                    id="remark"
                    name="remark"
                    placeholder="Enter remark"
                    value={remark}
                    onChange={onRemarkChange}
                    rows={4}
                    StartIcon={TbFileDescription}
                />
            </div>
            <Box className="leave-action-buttons">
                <Button
                    variant="contained"
                    color="error"
                    onClick={onReject}
                >
                    Reject
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    onClick={onAccept}
                    style={{ marginRight: 10 }}
                >
                    Accept
                </Button>
            </Box>
        </div>
    );
};

export default LeaveRequestActionView;
